var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 19,
    viewBox: "0 0 21 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1922 7.56568C20.0298 7.09438 19.5995 6.75432 19.0806 6.68273L13.8306 5.96285L11.4829 1.4805C11.0189 0.593576 9.48122 0.593576 9.01718 1.4805L6.66954 5.96285L1.43218 6.68273C0.913299 6.75432 0.483002 7.09637 0.322696 7.56568C0.160281 8.03698 0.297386 8.55005 0.672839 8.89408L4.46956 12.3742L3.57522 17.3C3.48663 17.7852 3.69967 18.2804 4.12153 18.5687C4.54549 18.8571 5.10867 18.8949 5.5706 18.6662L10.2511 16.3395L14.9443 18.6662C15.1447 18.7656 15.364 18.8153 15.5834 18.8153C15.8681 18.8153 16.1529 18.7318 16.3955 18.5687C16.8194 18.2764 17.0304 17.7852 16.9418 17.3L16.0474 12.3742L19.8442 8.89408C20.2196 8.55204 20.3546 8.035 20.1922 7.56568Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.b78720722151f40bd90028be596b287c.svg";
export { ForwardRef as ReactComponent };